import { parse, stringify } from "qs";

const createPaginationUrl = (
  path: string,
  query: ReturnType<typeof parse>,
  pageInPath?: boolean,
  page?: number | string,
  stringifyMethod = stringify,
) => {
  const pathName = pageInPath ? path.replace(/\/page\/\d+$/, "") : path;
  const { page: _, ...queryWithoutPage } = query;

  if (page) {
    const queryParams = stringifyMethod(
      pageInPath
        ? queryWithoutPage
        : {
            ...queryWithoutPage,
            page: String(page),
          },
    );

    return pageInPath
      ? `${pathName}/page/${page}${queryParams !== "" ? `?${queryParams}` : ""}`
      : `${pathName}?${queryParams}`;
  } else {
    const queryParams = stringifyMethod(queryWithoutPage);

    return `${pathName}${queryParams !== "" ? `?${queryParams}` : ""}`;
  }
};

export default createPaginationUrl;
